import {
	createContext,
	useContext,
	useEffect,
	useReducer,
} from "react";
import FormBannerReducer from "./FormBannerReducer";


const INITIAL_BANNER_STATE = {
	surveyBanner: JSON.parse(
		localStorage.getItem("ppmvBannerContent")
	),
};

export const FormBannerContext = createContext({
	surveyBanner: INITIAL_BANNER_STATE.surveyBanner,
	dispatch: () => null,
});

export const FormBannerProvider = ({ children }) => {
	const [state, dispatch] = useReducer(
		FormBannerReducer,
		INITIAL_BANNER_STATE
	);

	useEffect(() => {
		if (state.surveyBanner) {
			localStorage.setItem(
				"ppmvBannerContent",
				JSON.stringify(state.surveyBanner)
			);
		}
	}, [state.surveyBanner]);

	return (
		<FormBannerContext.Provider
			value={{ surveyBanner: state.surveyBanner, dispatch }}
		>
			{children}
		</FormBannerContext.Provider>
	);
};

export const useFormBannerContent = () => {
	const context = useContext(FormBannerContext);
	if (!context) {
		throw new Error("useForm must be used within a FormBannerProvider");
	}
	return context;
};
